import { render, staticRenderFns } from "./CoreChart-num1.vue?vue&type=template&id=5a128697&scoped=true&"
import script from "./CoreChart-num1.vue?vue&type=script&lang=js&"
export * from "./CoreChart-num1.vue?vue&type=script&lang=js&"
import style0 from "./CoreChart-num1.vue?vue&type=style&index=0&id=5a128697&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a128697",
  null
  
)

export default component.exports